// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rk2nNS1XlfxCeapCbEcf{width:100%;height:auto}.nHhypmB106EbYoxry7Pd{margin-top:1rem;margin-bottom:1rem}.UEKge8skpePwXKQ1iEYg{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": "rk2nNS1XlfxCeapCbEcf",
	"text": "nHhypmB106EbYoxry7Pd",
	"modal": "UEKge8skpePwXKQ1iEYg"
};
export default ___CSS_LOADER_EXPORT___;
